import { render, staticRenderFns } from "./MultipleUploadFile.vue?vue&type=template&id=8789df08&scoped=true"
import script from "./MultipleUploadFile.vue?vue&type=script&lang=js"
export * from "./MultipleUploadFile.vue?vue&type=script&lang=js"
import style0 from "./MultipleUploadFile.vue?vue&type=style&index=0&id=8789df08&lang=css"
import style1 from "./MultipleUploadFile.vue?vue&type=style&index=1&id=8789df08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8789df08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8789df08')) {
      api.createRecord('8789df08', component.options)
    } else {
      api.reload('8789df08', component.options)
    }
    module.hot.accept("./MultipleUploadFile.vue?vue&type=template&id=8789df08&scoped=true", function () {
      api.rerender('8789df08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Upload/MultipleUploadFile.vue"
export default component.exports